import * as React from 'react';
import { useState } from 'react';
import _ from 'lodash';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { SpanTxtStyle } from './topbarStyle';

const HelpModal = (props) => {
  const {
    editMode,
    isLoading,
    inputErrorMsg,
    modalData,
    handleModalSubmit,
    handleClose
  } = props;

  return (
    <Box
      sx={{
        width: { sx: '300px', md: '400px' },
        textAlign: 'start'
      }}
    >
      <Stack
        variant='center-center'
        sx={{ margin: '0 0 16px 0' }}
      >
        <Box mb={4}>
        <Typography variant='h5' style={{ lineHeight: 1.5 }}>
          只需輸入客戶<SpanTxtStyle>某一個廣告帳號編號（CID）</SpanTxtStyle>和日期區間，系統會自動更新該客戶<SpanTxtStyle>全部BQ表格全部廣告帳號</SpanTxtStyle>在該日期區間的資料。
        </Typography>

        </Box>

        <Button
          variant="fill-main"
          onClick={handleClose}
        >
          確定
        </Button>
      </Stack>

    </Box>
  )
}

export default HelpModal;